import CoreInputTextLabel from "./CoreInputTextLabel";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("Label", CoreInputTextLabel);
